module.exports = __webpack_public_path__ + "img/hero-icon-bones-2.0f0c0a64.svg";